import { MoonOutlined, SunOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import type React from "react";
import { useTheme } from "../context/ThemeContext";

const ThemeToggle: React.FC<{ className?: string }> = ({ className }) => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <Tooltip title={isDark ? "Switch to light mode" : "Switch to dark mode"}>
      <Button
        type="text"
        icon={isDark ? <SunOutlined /> : <MoonOutlined />}
        onClick={toggleTheme}
        className={className}
        aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
        style={{ fontSize: 18 }}
      />
    </Tooltip>
  );
};

export default ThemeToggle;
